/**
 * Module to fix issue when when changing orientation on IOS device
 */

/* eslint-disable */
import MobileDetect from 'mobile-detect';

function normalizeWidth() {
    document.body.style.width = window.innerWidth;
}

export default class iosRotationHandler {
    constructor() {
        const md = new MobileDetect(navigator.userAgent);

        if (md.is('iPhone') || md.is('iPad')) {
            normalizeWidth();
            this.bindEvents();
        }
    }

    bindEvents() {
        window.addEventListener('load', normalizeWidth);
        window.addEventListener('orientationchange', normalizeWidth);
    }
}



// WEBPACK FOOTER //
// ./lib/js/modules/iosRotationHandler.js